"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import Image from "next/image";
import { ImageIcon } from "lucide-react";

type CountryPortalTileProps = {
  id: string;
  name: string;
  href: string;
  logo: string;
  tags?: string[];
  labelText?: string;
  labelTextClassName?: string;
};

const CountryPortalTile = ({
  name,
  href,
  logo,
  tags,
  labelText,
  labelTextClassName
}: CountryPortalTileProps) => {

  return (
    <Link
      href={href}
      className={cn(
        "relative flex items-center justify-start gap-x-1.5 rounded-lg bg-white pl-2 pr-4 py-1"
      )}
    >
      {logo ? (
        <Image
          src={logo}
          alt="logo"
          width={80}
          height={80}
          className="h-9 w-9 rounded object-contain"
        />
      ) : (
        <ImageIcon className="h-5 w-5 text-gray-400" />
      )}

      <span className="text-sm font-medium text-gray-800">{name}</span>

      {tags && tags.length > 0 && (
        <span className="ml-1 text-xs text-gray-500">
          {tags[0]}
        </span>
      )}

      {labelText && labelTextClassName ? (
        <span className="absolute -right-5 -top-3 z-0">
          <span
            className={cn(
              "rounded bg-green-500697-country-portal-india-country-ui px-[5px] py-[1px] text-[10px] uppercase text-white",
              labelTextClassName
            )}
          >
            {labelText}
          </span>
        </span>
      ) : null}
    </Link>
  );
};

export default CountryPortalTile;
